/**
 * AppShell — the authenticated admin frame: auth gate + persistent AppNav +
 * the routed page.
 *
 * Mounted once as a react-router layout route, so the nav bar survives
 * navigation and `RequireAuth` is declared in one place instead of per-route.
 * Pages render their own sunken, padded column beneath it.
 *
 * The bar's hairline runs full-bleed while its contents sit in the same
 * gutter and max width the pages use, so the first destination lines up with
 * the page title below it.
 *
 * `TwoFactorGate` sits inside the auth gate: once the API refuses this
 * session for want of an authenticator code, the whole frame gives way to
 * the setup screen rather than each page showing the refusal.
 */
import { Outlet } from "react-router";
import { RequireAuth } from "../../lib/auth";
import { TwoFactorGate } from "../TwoFactorGate";
import { AppNav } from "./AppNav";
import styles from "./AppShell.module.css";

export function AppShell() {
  return (
    <RequireAuth>
      <TwoFactorGate>
        <div className={styles.shell}>
          <div className={styles.navBar}>
            <div className={styles.navInner}>
              <AppNav />
            </div>
          </div>
          <main className={styles.main}>
            <Outlet />
          </main>
        </div>
      </TwoFactorGate>
    </RequireAuth>
  );
}
